export default __webpack_public_path__ + "static/media/this-is-your-home-3.dee81fe3.webp";